import {useState, useEffect, MouseEvent} from 'react';
import './searchpanel.css';
import {FaExternalLinkSquareAlt} from 'react-icons/fa';

import {Tag} from 'src/components';
import {colorTag} from 'src/state/dependency2';
import {INVESTIGATE_USAGES_PATH} from 'src/routes';

import {SearchPanelProps} from './types';
import {ItemButton, Truncate} from './styled';
import {NodeResultObj, Meta} from './types';

export function SearchPanelResults(props: SearchPanelProps) {
  const [nodes, setNodes] = useState<Array<NodeResultObj>>([]);
  const [activeNodes, setActiveNodes] = useState<Array<NodeResultObj>>([]);
  const [activeId, setActiveId] = useState<Array<string>>([]);
  const [currentNodes, setCurrentNodes] = useState<Array<NodeResultObj>>([]);

  const navigateToInvestigateUsages = (nodeId: string) => window.open(INVESTIGATE_USAGES_PATH.replace('/:id/', `/${nodeId}/`), '_blank');

  const addToActive = (e:MouseEvent, node:NodeResultObj) => {
    if (e.ctrlKey) {
      if (!isNodeActive(node.id)) {
        const newSelectedNodes = [...activeNodes, node];
        setActiveNodes(newSelectedNodes);
        setCurrentNodes([...currentNodes, node]);
        setActiveId((activeId) => [...activeId, node.id]);
        props.submitNodeSearch(newSelectedNodes, 'combined');
      } else {
        const newActiveNodes = activeNodes.filter((item) => item.id !== node.id);
        setActiveNodes(newActiveNodes);
        setCurrentNodes(currentNodes.filter((cn) => cn.id !== node.id));
        setActiveId(activeId.filter((nodeId) => nodeId !== node.id));
        // props.removeNodeFromDiagram(node, newActiveNodes, 'combined');
        props.submitNodeSearch(newActiveNodes, 'combined');
      }
    } else if (e.shiftKey) {
      if (checkIsIncluded(activeNodes[activeNodes.length - 1].id, node.id)) {
        getAllBetween(activeId[activeId.length - 1], node.id);
      } else {
        getAllBetween(node.id, activeId[activeId.length - 1]);
      }
    } else {
      setActiveNodes([node]);
      setActiveId([node.id]);
      props.submitNodeSearch([node], 'fresh');
    }
  };

  const checkIsIncluded = (prevItem: string, currentItem: string) => {
    const prevItemIndex = nodes.findIndex((node) => node.id === prevItem);
    const currItemIndex = nodes.findIndex((node) => node.id === currentItem);
    return currItemIndex > prevItemIndex;
  };

  const getAllBetween = (start: string, end: string) => {
    const idArray = new Array(start);
    const startingPoint = nodes.findIndex((node) => node.id === start);
    const endingPoint = nodes.findIndex((node) => node.id === end);
    const selectedNodes: Array<NodeResultObj> = [...currentNodes];
    for (let i = startingPoint; i <= endingPoint; i++) {
      const currId = nodes[i].id;
      if (currId) {
        idArray.push(currId);
        const currNode = nodes.find((node) => node.id === currId);
        if (currNode) {
          selectedNodes.push(currNode);
        }
      } else {
        return;
      }
    }
    idArray.push(end);
    setActiveId([...activeId, ...idArray]);
    setCurrentNodes(selectedNodes);
    setActiveNodes(selectedNodes);
    props.submitNodeSearch(selectedNodes, 'combined');
  };

  const isNodeActive = (currId: string) => {
    return activeId.find((nodeId) => nodeId === currId);
  };

  useEffect(() => {
    if (props.nodeResults && props.nodeResults.length > 0) {
      const nodesWithMetaData = props.nodeResults.map((item) => {
        const colorObj = colorTag(item.primaryLabel);
        const metadata: Meta = {type: '', identity: ''};
        metadata.type = item.primaryLabel;
        metadata.identity = item.identity;
        return {...item, metadata, colorObj: colorObj};
      });
      setNodes(nodesWithMetaData);
    }
  }, [props.nodeResults]);

  useEffect(() => {
    setActiveId([]);
  }, [props.resetActive]);

  return (
    <div className='SearchPanelView__search-results'>
      <div className='SearchPanelView__search-results-list'>
        {nodes.map((node) => (
          <div key={node.id} style={{display: 'flex', flexDirection: 'row'}}>
            <ItemButton
              className={isNodeActive(node.id) ? 'active' : ''}
              style={{width: props.searchPanelWidth - 60}}
              key={node.id} color={node.colorObj?.color}
              id={node.id}
              title={node.parentName}
              onClick={(event)=> {
                addToActive(event, node);
              }}>
              <Truncate>{node.shortName ? node.shortName : node.name}</Truncate>
              <div className='SearchPanelView__item-type'>
                <Tag
                  backgroundColor={node.colorObj?.color}
                  color={node.colorObj?.fgColor}
                  label={node.primaryLabel}
                />
                <div className='SearchPanelView__root-name'>{node.scanRootName}</div>
              </div>
            </ItemButton>
            <button
              onClick={() => navigateToInvestigateUsages(node.id)}
              style={{display: 'inline', padding: '0 0 1rem', margin: 0, background: 'none', border: 'none'}}
              title='Investigate Usages'
            >
              <FaExternalLinkSquareAlt fontSize="1.35rem"></FaExternalLinkSquareAlt>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
